import { Box } from '@mui/material';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '../../../lib/components/atomic/surface/logo';
import { useParams } from 'react-router';
import BenefitPlatformLogo from '../../../lib/logos/benefit_platform.svg?react';

export const LoginLogo: FC = () => {
  const { i18n } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang) i18n.changeLanguage(lang);
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        padding: '0 32px 32px 32px ',
        borderRadius: '24px'
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          paddingY: '1em'
        }}
      >
        <Logo
          variant="duo-blue"
          sx={{
            height: '5.5rem',
            marginTop: '3.875rem'
          }}
        />
        <BenefitPlatformLogo style={{ marginLeft: '6rem', marginTop: '0.375rem' }} />
      </Box>
    </Box>
  );
};
